import memoize from 'memoizerific';
import valid from 'card-validator';
import loSnakeCase from 'lodash/snakeCase';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import {imageRoot} from "../env.config";

export function setLhnConfig() {
  if (typeof window !== 'undefined') {
    window.lhnAccountN = "30577-1";
    window.lhnButtonN = 8319;
    window.lhnChatPosition = 'righttab';
    window.lhnInviteEnabled = 1;
    window.lhnWindowN = 0;
    window.lhnDepartmentN = 36164;
  }
}

export const cachedJsonParse = memoize(50)(JSON.parse);
export const emailRegex = /^[\w.%+-]+@([\w-]+\.)+[a-zA-Z]{2,}$/;


export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const padNumber = (num) => {
  return `${num > 9 ? '' : 0}${num}`;
};

export const snakeCase = (str) => {
  if (/^[a-z]+\d+$/.test(str)) {
    return str;
  }
  return loSnakeCase(str);
};

export const months = ['Jan', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const serializeQueryParams = (params) => {
  return Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
};

export const validateRequiredFields = (requiredFields, formData, formErrors) => {
  for (let field of requiredFields) {
    let fieldValue = get(formData, field);
    if (!fieldValue && fieldValue !== 0) {
      formErrors[field] = 'Field is required';
    }
  }
  return formErrors;
};

export const isEnterPressed = e => {
  if (e.key === 'enter') return true;
  const code = e.keyCode ? e.keyCode : e.which;
  return code === 13;
};

export const homePageImageRotatorLinks = [
  {
    filename: `${imageRoot}Chandelier.png`,
    link: "/product-search/?cat=204"
  },
  {
    filename: `${imageRoot}Loveseat.png`,
    link: "/Product-Search/?cat=473&sw=loveseat"
  },
  {
    filename: `${imageRoot}Refrigerators.png`,
    link: "/product-search/?cat=1590"
  },
  {
    filename: `${imageRoot}Vanity.png`,
    link: "/Product-Search/?cat=1334&sw=vanity"
  },
  {
    filename: `${imageRoot}OLED-TV.png`,
    link: "/product-search/?cat=164"
  },
  {
    filename: `${imageRoot}WasherDryer.png`,
    link: "/product-search/?cat=571"
  }
];

export const brandImageLinks = [
  '/homepage/brands/01_kitchenaid-logo.svg',
  '/homepage/brands/02_frigidaire-logo.svg',
  '/homepage/brands/03_samsung-logo.svg',
  '/homepage/brands/04_armstrong-logo.svg',
  '/homepage/brands/05_hunterdouglas-logo.svg',
  '/homepage/brands/06_robert allen-logo.svg',
  '/homepage/brands/07_masterbrand-logo.svg',
  '/homepage/brands/08_eq3.svg',
  '/homepage/brands/09_palliser-logo.svg',
  '/homepage/brands/10_whirlpool-logo.svg',
  '/homepage/brands/11_kohler-logo.svg',
  '/homepage/brands/12_moen-logo.svg',
  '/homepage/brands/13_bosch-logo.svg',
  '/homepage/brands/14_electrolux-logo.svg',
  '/homepage/brands/15_maytag-logo.svg',
  '/homepage/brands/16_mohawk.svg',
  '/homepage/brands/17_feiss.svg',
  '/homepage/brands/18_hooker furniture-logo.svg'
];

export const departmentLinks = [
  {label: 'Furniture', link: '/us/products/furniture/451/'},
  {label: 'Appliances', link: '/us/products/appliances/555/'},
  {label: 'Home Improvement', link: '/us/products/home-improvement/92/'},
  {label: 'Mattresses, Box Springs & Frames', link: '/us/products/mattresses-box-springs-frames/538/'},
  {label: 'Lighting & Fans', link: '/us/products/lighting-fans/196/'},
  {label: 'Decor', link: '/us/products/decor/367/'},
  {label: 'Kitchen & Tabletop', link: '/us/products/kitchen-tabletop/1407/'},
  {label: 'Outdoor', link: '/us/products/outdoor/236/'},
  {label: 'Electronics', link: '/us/products/electronics/148/'},
  {label: 'Health, Fitness & Sports', link: '/us/products/health-fitness-sports/326/'},
  {label: 'Travel, Jewelry & Accessories', link: '/us/products/travel-jewelry-accessories/284/'},
  {label: 'Apparel', link: '/us/products/apparel/320/'},
];

export const creditCardOptions = [
  {value: '1', label: 'Visa'},
  {value: '2', label: 'Mastercard'},
  {value: '3', label: 'Discover'},
  {value: '4', label: 'American Express'},
];

export const checkCreditCardType = (cc_number) => {
  const card = valid.number(cc_number).card;
  if (card) {
    return get(find(creditCardOptions, ['label', card.niceType]), 'value');
  }
  return null;
};

export const checkCreditCard = (cardNumber, cardType, cvv, expirationMonth, expirationYear, union = false) => {
  const cardTypeFromNumber = checkCreditCardType(cardNumber);
  if (!(cardType === cardTypeFromNumber)) {
    return {CardType: 'Card number does not match card type'};
  } else if (!valid.cvv(cvv, 4).isValid && cardType === '4') {
    return {CVV: 'CVV for American Express Card should be 4 digits'};
  } else if (!valid.cvv(cvv, 3).isValid && cardType !== '4') {
    return {CVV: 'CVV should be 3 digits'};
  } else if (!valid.number(cardNumber).isValid) {
    return {CardNumber: 'You have entered an invalid credit card number'};
  } else if (!valid.expirationMonth(expirationMonth).isValid) {
    const errorMsg = 'Expiration month is invalid';
    return union ? {Expiration: errorMsg} : {ExpirationMonth: errorMsg};
  } else if (!valid.expirationYear(expirationYear).isValid) {
    const errorMsg = 'Expiration year is invalid';
    return union ? {Expiration: errorMsg} : {ExpirationMonth: errorMsg}
  }
  return {};
};

export const checkCreditCardExpiration = (month, year) => {
  if (month && year && +month <= 12) {
    const today = new Date();
    // when you build a date in the following way the month is 1 greater than
    // the integer e.g. may=4 - the only false test will be if the day is
    // the first day of the month (at the correct millisecond)
    // It does accept int > 11 for month, in which case gets rolled over to the next year
    // eg. 14/19 would give March 2020
    const n = new Date(+year, +month, 1);
    return today < n;
  }
  return false;
};

export const defaultTrackingId = '531393';

export function getPenguinsData(path) {
  if (typeof window !== 'undefined') {
    const penguins_data = get(window, 'penguins_data', {});
    return get(penguins_data, path);
  }
  return null;
}

export function stringOnlyContainsDigit(s) {
  return s.match(/^[0-9]+$/) != null || isEmpty(s);
}

export function isUSA(country) {
  return country === 'usa';
}

export function isCAN(country) {
  return country === 'can';
}
